import { LcpUserPageWrapper } from "Components/MainPageWrapper";
import { Section } from "Components/Section";
import React from "react";
import { Link } from "react-router-dom";
import { AdminPaths } from "./Paths";

export function ApplicationNotFoundPage() {
  return (
    <LcpUserPageWrapper documentTitle="Application Not Found">
      <Section title="Application Not Found">
        This application could not be found.
        <div className="has-text-centered" style={{ marginTop: "1em" }}>
          <Link className="button is-primary" to={AdminPaths.AdminDashboard}>
            Return to Dashboard
          </Link>
        </div>
      </Section>
    </LcpUserPageWrapper>
  );
}
